import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_END_POINT } from "config";

const apiSlice = createApi({
    reducerPath: "projectapi",
    baseQuery: fetchBaseQuery({
        baseUrl: API_END_POINT,
        prepareHeaders: (headers, { getState }) => {

            const token = getState()?.auth?.token;
            // if (token) {
            headers.set("Authorization", `Bearer ${localStorage.getItem('token')}`);
            //headers.set("content-type", "application/json" );
            // }
            return headers;
        },
    }),
    endpoints: (builder) => ({
    }),
});

const projectApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Add New Project
        addProject: builder.mutation({
            query: (project) => ({
                url: `${API_END_POINT}project`,
                method: 'POST',
                body: project,
            }),
            providesTags: ["Add-New-Project"],
        }),

        // Get All Projects
        getAllProjects: builder.query({
            query: () => ({
                url: `${API_END_POINT}project`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Get-All-Projects"],
        }),

        // Update Project
        updateProject: builder.mutation({
            query: ({ _id, project }) => ({
                url: `${API_END_POINT}project/${_id}`,
                method: 'PUT',
                body: project,
            }),
            providesTags: ["Update-Project"],
        }),

        // Delete Project
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `${API_END_POINT}project/${id}`,
                method: 'DELETE',
            }),
            providesTags: ["Delete-Project"],
        }),
        // Get All Projects
        getProjectDetail: builder.query({
            query: (id) => ({
                url: `${API_END_POINT}project/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

export default projectApiSlice;

export const {
    useGetProjectDetailQuery,
    useAddProjectMutation,
    useGetAllProjectsQuery,
    useUpdateProjectMutation,
    useDeleteProjectMutation,
} = projectApiSlice;